export async function getDevices(kind: MediaDeviceKind) {
  if (!navigator.mediaDevices) {
    console.error('media device not allowed');
    return;
  }

  const devices = (await navigator.mediaDevices.enumerateDevices()).filter((d) => d.kind === kind);

  // Default device를 array 첫 번째에 위치시킨다
  const defaultIdDevice = devices.find((d) => d.deviceId === 'default');
  if (defaultIdDevice) {
    return [
      defaultIdDevice,
      ...devices.filter((device) => device.deviceId !== defaultIdDevice.deviceId),
    ];
  }

  return devices;
}

export async function getDefaultDevice(kind: MediaDeviceKind) {
  const devices = await getDevices(kind);
  if (!devices) {
    return;
  }
  return devices.find((d) => d.kind === kind);
}

export async function getDeviceByDeviceId(deviceId: MediaDeviceInfo['deviceId']) {
  if (!navigator.mediaDevices) {
    console.error('media device not allowed');
    return;
  }

  const devices = await navigator.mediaDevices.enumerateDevices();
  return devices.find((d) => d.deviceId && d.deviceId === deviceId);
}

export async function checkValidDevice(deviceId: string) {
  return !!(await getDeviceByDeviceId(deviceId));
}

export const supportsHover = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(any-hover: hover)')?.matches ?? false;
};
